module.exports = __webpack_public_path__ + "static/4_2_recommendation_CS-643dbeb0a81ed3a01fec1d76d238a4d5.svg";